import {useLayoutEffect, useState} from 'react'

import newsDefault1Png from '../../../assets/media/news-default-1.png'
import newsDefault2Png from '../../../assets/media/news-default-2.png'
import newsDefault3Png from '../../../assets/media/news-default-3.png'
import newsDefault4Png from '../../../assets/media/news-default-4.png'
import newsDefault5Png from '../../../assets/media/news-default-5.png'

const newsDefaults = [newsDefault1Png, newsDefault2Png, newsDefault3Png, newsDefault4Png, newsDefault5Png];

function getRandomImage() {
   return newsDefaults[Math.floor(Math.random() * newsDefaults.length)];
};

const NewsAvatar = ({photo, size, alt, ...props}) => {
  const [randomPhoto, changeRandomPhoto] = useState(null)

  useLayoutEffect(()=> {
    changeRandomPhoto(getRandomImage())
  }, [changeRandomPhoto])

    return <img src={photo ?? randomPhoto} style={{width: size, height: size, borderRadius: '100%'}} alt={alt} {...props} />
}

export default NewsAvatar